import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { HttpModule, JsonpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from "@angular/forms";
import { ErrorHandler } from "@angular/core";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpHelper } from './common/helpers/http.helper';
import { LoggingService } from './common/logging/logging.service';
import { ErrorHandlingService } from './common/exception/error-handling.service';
import { BootstrapSWAlertService } from './common/services/bootstrap-SWAlert.service';
import { AppRoutingModule } from './app-routing.module';
import { PageNotFoundComponent } from './common/components/page-not-found/page-not-found.component';
import { HomeModule } from './home/home.module';
import { UserService } from './common/services/user.service';
import { ConfigurationService } from "./crm/services/configuration.service";
import { MyCompanyService } from "./crm/services/my-company.service";
import { AffiliateService } from "./crm/services/affiliate.service";
// import { CKEditorModule } from 'ng2-ckeditor';
import { ToastModule, ToastOptions } from 'ng2-toastr';
import { TextMaskModule } from 'angular2-text-mask';
import { ToastCustomOption } from '../toastcustomoptions';
import { ContactService } from './crm/services/contact.service';
import { DataSharingService } from './common/services/data-sharing.service';
import { MenuLeftComponent } from './common/components/menu-left/menu-left.component';
import { MenuRightComponent } from './common/components/menu-right/menu-right.component';
import { CRMLeftBarComponent } from './crm/components/menus/left-bar/crm-left-bar.component';
import { SearchPipe } from './common/pipe/search.pipe';
import { WorkFlowComponent } from './crm/components/screens/contact/customer-detail/work-flow/work-flow.component';
import { PreArrangedRoadmapComponent } from './crm/components/screens/my-company/pre-arranged-roadmap/pre-arranged-roadmap.component';
import { PermissionService } from './security/permission.service';
import { EmployeeService } from '../app/crm/services/employee.service';
import { DateService } from './common/services/date.service';
import { PipeModule } from './common/pipe/pipe.module';
import { AuthService } from './common/services/auth.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BROWSER_FAVICONS_CONFIG, Favicons, BrowserFavicons } from './favicon.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TimeoutInterceptor, DEFAULT_TIMEOUT } from './common/interceptors/timeout.interceptor';
import { JoinViaCreditUpClub } from './join-via-creditupclub/join-via-creditupclub.component';
import { SiteMaintenanceComponent } from './site-maintenance/site-maintenance.component';
import { QuillModule } from 'ngx-quill';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    MenuLeftComponent,
    MenuRightComponent,
    CRMLeftBarComponent,
    WorkFlowComponent,
    PreArrangedRoadmapComponent,
    SearchPipe,
    JoinViaCreditUpClub,
    SiteMaintenanceComponent
  
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    NgbModule.forRoot(),
    HttpModule,
    JsonpModule,
    RouterModule,
    AppRoutingModule,
    HomeModule,
    //CKEditorModule,
    // ModalModule.forRoot(),
    // BootstrapModalModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule.forRoot(),
    TextMaskModule,
    PipeModule,
    HttpClientModule,
    PdfViewerModule,
    QuillModule
  ],
  providers: [
    HttpHelper,
    ErrorHandlingService,
    LoggingService,
    { provide: ErrorHandler, useClass: ErrorHandlingService },
    BootstrapSWAlertService,
    UserService,
    ContactService,
    ConfigurationService,
    MyCompanyService,
    AffiliateService,
    { provide: ToastOptions, useClass: ToastCustomOption },
    DataSharingService,
    PermissionService,
    EmployeeService,
    DateService,
    AuthService,
    {
      provide: Favicons,
      useClass: BrowserFavicons
    },
    {
      provide: BROWSER_FAVICONS_CONFIG,
      useValue: {
        icons: {
          "home-roadmap": {
            type: "image/png",
            href: "../assets/image/home-roadmap-favicon.ico",
          },
          "credit-augmentor": {
            type: "image/jpeg",
            href: "../assets/image/credit-augmentor-favicon.ico"
          },
          "credit-repair-update": {
            type: "image/png",
            href: "../assets/image/credir-repair-update-favicon.ico"
          },
          "creditup-club":{
            type:"image/png",
            href:"../assets/image/credit-up-club-favicon.png"
          }
        },
        cacheBusting: true
      }
    },
    { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
    { provide: DEFAULT_TIMEOUT, useValue: 300000 },
  ],
  bootstrap: [AppComponent],
  entryComponents: []
})
export class AppModule { }


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/app.module.ts